import { render, staticRenderFns } from "./UmsApplicationsCount.vue?vue&type=template&id=59af7936&"
import script from "./UmsApplicationsCount.vue?vue&type=script&lang=js&"
export * from "./UmsApplicationsCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports